import { render } from "./ServiceDetailComponent.vue?vue&type=template&id=5b5c2df8"
import script from "./ServiceDetailComponent.vue?vue&type=script&lang=js"
export * from "./ServiceDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/phi-indonesia/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__